import {createContext, useContext, useEffect, useState} from 'react'

import {isEqual} from 'lodash'

const FormDirtyContext = createContext()

export const FormDirtyProvider = ({children, initialFormValues}) => {
  const [isDirty, setIsDirty] = useState(false)
  const [initialValues, setInitialValues] = useState(initialFormValues)
  const [hasSavedImage, setHasSavedImage] = useState(
    !!initialFormValues?.measuresSection?.measurementImage || false
  )

  useEffect(() => {
    if (initialFormValues) {
      setHasSavedImage(!!initialFormValues?.measuresSection?.measurementImage)
      setInitialValues(initialFormValues)
      setIsDirty(false)
    }
  }, [initialFormValues])

  const updateDirtyState = currentValues => {
    setIsDirty(!isEqual(initialValues, currentValues))
  }

  const resetIsDirty = newValues => {
    setInitialValues(newValues)
    setIsDirty(false)
  }

  const value = {
    isDirty,
    resetIsDirty,
    updateDirtyState,
    hasSavedImage,
    setHasSavedImage
  }

  return (
    <FormDirtyContext.Provider value={value}>
      {children}
    </FormDirtyContext.Provider>
  )
}

export const useFormDirty = () => {
  const context = useContext(FormDirtyContext)

  if (context === undefined) {
    throw new Error('useFormDirty must be used within a FormDirtyProvider')
  }

  return context
}
